import React, { useState, useEffect } from "react";
import axios from "axios";
import { auth } from "../firebase/firebaseConfig";
import "../styles/MerciaChat.css"; // Arquivo de estilos

const MerciaChat = () => {
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState([]);
  const [userId, setUserId] = useState(null);
  const [isOpen, setIsOpen] = useState(false); // Controla o modal

  useEffect(() => {
    auth.onAuthStateChanged(user => {
      setUserId(user ? user.uid : null);
    });
  }, []);

  const sendMessage = async () => {
    if (!input.trim()) return;

    const userMessage = { role: "user", content: input };
    setMessages([...messages, userMessage]);

    setInput("");

    try {
      const { data } = await axios.post("https://api.rondago.com.br/api/merciaChat", {
        message: input,
        userId: userId,
      });

      // Verifica se há uma resposta válida do Gemini
      const geminiResponse = data.response || "Não consegui entender sua pergunta. Tente novamente!";

      setMessages([...messages, userMessage, { role: "assistant", content: geminiResponse }]);
    } catch (error) {
      console.error("Erro ao obter resposta da IA:", error);
      setMessages([...messages, { role: "assistant", content: "Ops! Algo deu errado ao tentar responder." }]);
    }
  };

  return (
    <>
      {/* Botão Flutuante para abrir o chat */}
      <button className="mercia-chat-button" onClick={() => setIsOpen(true)}>
        💬 Chat
      </button>

      {/* Modal do Chat */}
      {isOpen && (
        <>
          {/* 🔹 Overlay para escurecer o fundo e destacar o modal */}
          <div className="mercia-chat-overlay" onClick={() => setIsOpen(false)}></div>

          <div className="mercia-chat-modal">
            <div className="mercia-chat-header">
              <img src="/assets/mercia-avatar.png" alt="Mércia" className="mercia-avatar" />
              <span>Mércia - Síndica Virtual</span>
              <button className="close-btn" onClick={() => setIsOpen(false)}>✖</button>
            </div>

            <div className="mercia-chat-messages">
              {messages.map((msg, index) => (
                <p key={index} className={msg.role === "user" ? "user-msg" : "bot-msg"}>
                  {msg.content}
                </p>
              ))}
            </div>

            <div className="mercia-chat-input">
              <input
                value={input}
                onChange={(e) => setInput(e.target.value)}
                placeholder="Pergunte algo..."
              />
              <button onClick={sendMessage}>Enviar</button>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default MerciaChat;
